var exports = {
  "kL": "WebhookListItem.module__container___NUt2Q2",
  "aY": "WebhookListItem.module__headerButton___NUt2Q2",
  "kb": "WebhookListItem.module__left___NUt2Q2",
  "Jb": "WebhookListItem.module__avatarLarge___NUt2Q2",
  "fI": "WebhookListItem.module__textBlock___NUt2Q2",
  "$": "WebhookListItem.module__titleRow___NUt2Q2",
  "UU": "WebhookListItem.module__name___NUt2Q2",
  "ML": "WebhookListItem.module__channelTag___NUt2Q2",
  "KW": "WebhookListItem.module__metaRow___NUt2Q2",
  "K9": "WebhookListItem.module__channelTagMobile___NUt2Q2",
  "ai": "WebhookListItem.module__chevron___NUt2Q2",
  "hg": "WebhookListItem.module__chevronExpanded___NUt2Q2",
  "zH": "WebhookListItem.module__details___NUt2Q2",
  "J1": "WebhookListItem.module__detailsRow___NUt2Q2",
  "Mc": "WebhookListItem.module__avatarColumn___NUt2Q2",
  "Pf": "WebhookListItem.module__label___NUt2Q2",
  "_Q": "WebhookListItem.module__avatarPreview___NUt2Q2",
  "OA": "WebhookListItem.module__fields___NUt2Q2",
  "EN": "WebhookListItem.module__fieldsRow___NUt2Q2",
  "ch": "WebhookListItem.module__fieldGrow___NUt2Q2",
  "o1": "WebhookListItem.module__actions___NUt2Q2",
  "Dy": "WebhookListItem.module__avatarActions___NUt2Q2",
  "B": "WebhookListItem.module__urlWrapper___NUt2Q2",
  "UQ": "WebhookListItem.module__monoInput___NUt2Q2",
  "Bx": "WebhookListItem.module__iconSmall___NUt2Q2",
  "xv": "WebhookListItem.module__truncate___NUt2Q2",
};

module.exports = exports;
